import SlickImport from 'react-slick';

// react-slick ships CJS; under Vite 8 the default import can resolve to the module namespace object
// (`{ default: SliderClass, __esModule: true }`) instead of the class itself, which makes React throw
// "Element type is invalid". Unwrap the namespace defensively so the value is always the Slider class.
interface SlickModule {
  default?: typeof SlickImport;
}
const Slick = (SlickImport as SlickModule).default ?? SlickImport;
type Slick = SlickImport;

// Use a named export so TypeScript carries both the value (class) and the type (instance) bindings.
export { Slick };
